import { Outlet } from 'react-router'

/**
 * Marketing layout that renders without the Epic Stack header/footer
 * This allows the landing page to have its own custom navigation and footer
 */
export default function MarketingLayout() {
	return <Outlet />
}
